import { SortingState } from "@tanstack/react-table";
import { useCallback, SetStateAction } from "react";

const useSortingHandler = (
  page: number,
  pageSize: number,
  sorting: SortingState,
  updateUrlParams: (
    newPage?: number,
    newPageSize?: number,
    newSorting?: SortingState,
  ) => void,
) => {
  return useCallback(
    (newSorting: SetStateAction<SortingState>) => {
      if (typeof newSorting === "function") {
        updateUrlParams(page, pageSize, newSorting(sorting));
      } else {
        updateUrlParams(page, pageSize, newSorting);
      }
    },
    [page, pageSize, sorting, updateUrlParams],
  );
};

export default useSortingHandler;
